import React from 'react';
import { Phone, Mail } from 'lucide-react';
import { motion } from 'framer-motion';
export function ContactBanner() {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} className="bg-brand rounded-2xl overflow-hidden shadow-lg my-12 relative" data-id="element-17">
      <div className="absolute top-0 right-0 -mt-16 -mr-16 w-64 h-64 bg-brand-light rounded-full opacity-15 blur-3xl" data-id="element-18"></div>
      <div className="absolute bottom-0 left-0 -mb-16 -ml-16 w-48 h-48 bg-brand-muted rounded-full opacity-10 blur-3xl" data-id="element-19"></div>
      <div className="absolute top-0 left-0 right-0 h-1 bg-brand-muted/60" data-id="element-20"></div>

      <div className="px-6 py-10 md:py-12 md:px-12 relative z-10 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-21">
        <div className="max-w-xl text-center md:text-left" data-id="element-22">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-23">
            Ready to explore your options?
          </h2>
          <p className="text-blue-100 text-lg" data-id="element-24">
            Whether you're looking to refinance, pull cash out, or purchase a
            new property — Sarah is here to help you navigate the market.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 w-full md:w-auto shrink-0" data-id="element-25">
          <a href="tel:+12485379200" className="flex justify-center items-center gap-2 bg-white hover:bg-gray-100 text-brand px-8 py-4 rounded-xl font-bold text-lg transition-colors shadow-md w-full sm:w-auto" data-id="element-26">
            <Phone className="w-5 h-5" data-id="element-27" />
            Call Sarah
          </a>
          <a href="mailto:sarah@rapidhomelending.com" className="flex justify-center items-center gap-2 bg-brand-light hover:bg-brand-muted border border-blue-400/30 text-white px-8 py-4 rounded-xl font-bold text-lg transition-colors shadow-sm w-full sm:w-auto" data-id="element-28">
            <Mail className="w-5 h-5" data-id="element-29" />
            Email
          </a>
        </div>
      </div>
    </motion.div>;
}